// Though CohortSelector is a server component and this could be in the same
// file, it's separate to avoid circular dependency between PDP and course page.
export const cohortSelectorFragment = `
  fragment cohortSelectorFragment on CohortSelectorModuleRecord {
    cohortCardButtonText
    fullTimeTabTitle
    highlightText
    partTimeTabTitle
    subtitle
    title
  }
`;
